


















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OperatorModel } from '@/models/Operator';

const module = namespace('OperatorStore');

@Component
export default class BulkTargeting extends Vue {
    @module.State private operators!: OperatorModel[];

    @module.Action('changeIsTargetGrouping') private changeIsTargetGrouping!: (payload: { changed: boolean, ids: number[]}) => void;

    private visibleIsTarget: string = '1';

    private changeType: string = '1';

    private callChangeTargeting() {
        const visibleIsTarget = this.visibleIsTarget === '1';
        const changed = ['1', '2'].includes(this.changeType);
        this.changeTargeting(visibleIsTarget, changed);
        if (this.changeType === '1') {
            this.changeTargeting(!visibleIsTarget, !changed);
        }
    }

    private changeTargeting(visibleIsTarget: boolean, changed: boolean) {
        let targets = this.operators.filter((operator) => operator.visible === visibleIsTarget );
        if ( changed ) {
            const onlyCnVers = targets.filter((operator) => operator.onlyCnVer );
            let isOkOnlyCnVer;
            if ( onlyCnVers.length > 0 ) {
                isOkOnlyCnVer = window.confirm('大陸版のみのオペレーターが含まれていますがグループ対象に追加してよいですか？\n※キャンセルで大陸版のみオペレーター以外をグループ対象に追加');
            }
            if (!isOkOnlyCnVer) {
                targets = targets.filter((operator) => !operator.onlyCnVer);
            }
        }
        const targetIds = targets.map((operator) => operator.id );
        this.changeIsTargetGrouping({ changed: changed, ids: targetIds });
    }
}
